import React from "react";
import { Link } from "react-router-dom";
import "./Health.css";

const Health = () => {
  return (
    <section className="health-section section-padding">
      <div className="container">
        <div className="row align-items-center g-5">
          <div className="col-lg-6 col-md-12">
            <span className="section-header-pill">
              <i className="fa-solid fa-bone me-1"></i> Specialised Joint Care
            </span>
            <h2 className="section-title-large mb-3">
              Comprehensive Care for Knee, Shoulder & Sports Injuries
            </h2>
            <p className="health-lead mb-4">
              Dr. Sunil Apsingi integrates advanced arthroscopic (keyhole) surgery with evidence-based joint reconstruction. From competitive athletes with acute ACL tears to seniors suffering from degenerative arthritis, each patient receives an individualized surgical and rehabilitation pathway.
            </p>

            <div className="specialty-checklist mb-4">
              <div className="check-item d-flex align-items-center gap-3 mb-2">
                <i className="fa-solid fa-circle-check text-teal"></i>
                <span>Minimally invasive knee ACL, PCL & meniscal repair</span>
              </div>
              <div className="check-item d-flex align-items-center gap-3 mb-2">
                <i className="fa-solid fa-circle-check text-teal"></i>
                <span>Shoulder dislocation, Bankart repair & rotator cuff reconstruction</span>
              </div>
              <div className="check-item d-flex align-items-center gap-3 mb-2">
                <i className="fa-solid fa-circle-check text-teal"></i>
                <span>Robotic & Computer-navigated total/partial knee replacement</span>
              </div>
              <div className="check-item d-flex align-items-center gap-3">
                <i className="fa-solid fa-circle-check text-teal"></i>
                <span>Reverse shoulder arthroplasty & cartilage restoration</span>
              </div>
            </div>

            <div className="d-flex flex-wrap gap-3">
              <Link to="/aboutus" className="btn-medical-primary">
                Read Doctor's Profile <i className="fa-solid fa-arrow-right ms-2"></i>
              </Link>
              <Link to="/services" className="btn-medical-secondary">
                View All Surgeries
              </Link>
            </div>
          </div>

          <div className="col-lg-6 col-md-12">
            <div className="health-visual-grid">
              <div className="visual-card knee-card">
                <img
                  src="/images/image-(3).png"
                  alt="Knee Replacement Surgery"
                  className="visual-img"
                />
                <div className="visual-overlay">
                  <span className="visual-tag">Precision Arthroplasty</span>
                  <h5 className="visual-title mb-0">Total Knee Replacement</h5>
                </div>
              </div>
              <div className="visual-card shoulder-card">
                <img
                  src="/images/image-(4).png"
                  alt="Shoulder Arthroscopy Surgery"
                  className="visual-img"
                />
                <div className="visual-overlay">
                  <span className="visual-tag">Arthroscopy</span>
                  <h5 className="visual-title mb-0">Shoulder Reconstruction</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Health;
